import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { CreateChancel, CustomNumericFormat, DateCalendarForm } from 'components';
import { FindErrorItem, FindLoad, FindSuccessItem, useModal } from 'utils';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, payrollActions } from 'store';

export const MileageCompensation = ({ info }) => {
    const dispatch = useDispatch();
    const { close } = useModal();
    const ACTION_TYPE = info ? 'EDIT_MILEAGE' : 'CREATE_MILEAGE';
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: {
            compensation: info?.compensation || '',
            startDate: info ? moment(info.startDate).format().substring(0, 10) : '',
        },
    });

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            if (!info) {
                reset({ compensation: '', startDate: '' });
            }
        }
    }, [success]);

    useEffect(() => {
        return () => {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);

    const getBackErrorText = () => {
        if (backError?.error === 'can not be two active mileage') {
            return 'Can not be two active mileage';
        } else if (backError?.error === 'Mileage overlapping') {
            return 'Mileage overlapping';
        } else if (backError?.error === 'can not update the mileage because mileage was terminated') {
            return 'Can not update the mileage because mileage was terminated';
        }
        return '';
    };

    const handleSave = (e) => {
        e && e.preventDefault();
        if (backError) dispatch(httpRequestsOnErrorsActions.removeError(backError.type));
        handleSubmit((data) => {
            const payload = {
                compensation: +data.compensation,
                startDate: data.startDate,
            };
            if (info) {
                dispatch(payrollActions.editMileage(info?.id, payload));
            } else {
                dispatch(payrollActions.createMileage(payload));
            }
        })(e);
    };

    const backErrorText = getBackErrorText();

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Mileage Compensation' : 'Add Mileage Compensation'}</p>
            <form onSubmit={handleSave}>
                <div className="modal-body-wrapper">
                    <Controller
                        name="compensation"
                        control={control}
                        rules={{ required: 'Mileage compensation is required.' }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <CustomNumericFormat
                                prefix={'$'}
                                name={'compensation'}
                                label={'$ Mileage Compensation*'}
                                value={value}
                                handleChangeMiles={(val) => onChange(val?.value)}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                decimalScale={4}
                                error={error?.message || backErrorText}
                                errorName={error || backErrorText ? 'compensation' : ''}
                            />
                        )}
                    />
                    <DateCalendarForm
                        control={control}
                        name={'startDate'}
                        label={'Start Date*'}
                        rules={{ required: 'Start date is required.' }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
